"use client";

import Link from "next/link";
import Image from "next/image";
import { Card, CardContent } from "@/components/ui/card";
import { Users, GraduationCap } from "lucide-react";
import { MobileMenuButton } from "@/components/ui/mobile-menu-button";
import { useI18n } from "@/lib/i18n";

export const dynamic = "force-static";

export default function CourseIndexPage() {
  const { t } = useI18n();

  return (
    <>
      <MobileMenuButton />
      <div className="container mx-auto px-4 py-8">
      {/* Header - align with /history style */}
      <div className="mb-6 space-y-2">
        <div className="flex items-center gap-3">
          <GraduationCap className="w-8 h-8" />
          <h1 className="text-2xl sm:text-3xl font-bold">{t("course.index.title")}</h1>
        </div>
        <p className="text-muted-foreground">{t("course.index.subtitle")}</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <Card className="overflow-hidden hover:shadow-lg transition-shadow group rounded-xl">
          <Link href="/course/most-common-american-idioms" className="flex items-center space-x-4 p-4">
            <div className="relative flex-shrink-0 w-24 sm:w-28 aspect-[3/4] rounded-md overflow-hidden border">
              <Image
                src="/images/cover.png"
                alt={t("course.index.cards.idioms.coverAlt")}
                fill
                className="object-cover transition-transform duration-300 group-hover:scale-105"
                priority
                sizes="(max-width: 640px) 96px, (max-width: 1024px) 112px, 112px"
              />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex items-center justify-between">
                <p className="text-sm text-muted-foreground truncate">
                  {t("course.index.cards.idioms.provider")}
                </p>
                <div className="flex items-center bg-black text-white px-2 py-0.5 rounded-md">
                  <Users className="h-3.5 w-3.5 text-yellow-400" />
                  <span className="text-xs font-semibold ml-1">295</span>
                </div>
              </div>
              <p className="text-lg font-bold mt-1 group-hover:underline">
                {t("course.index.cards.idioms.title")}
              </p>
              <p className="text-sm text-muted-foreground mt-1 truncate">
                {t("course.index.cards.idioms.description")}
              </p>
            </div>
          </Link>
        </Card>
      </div>
    </div>
    </>
  );
}
